import { FieldValues } from 'react-hook-form';

export interface SignedOutAuth {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state: any;
}

export interface SignedInAuth {
  accessToken?: string;
  idToken?: string;
  refreshToken?: string;
  transientUserKey?: string;
}

export type Auth = SignedInAuth | SignedOutAuth;

export enum HttpRequestType {
  HTTP_PUT = 'PUT',
  HTTP_POST = 'POST',
  HTTP_DELETE = 'DELETE',
  HTTP_PATCH = 'PATCH',
}

export type UserLogin = FieldValues & {
  email: string;
  password: string;
};

export type UserRegistration = UserLogin & {
  /** accepted_terms will be deprecated in favor of accepted_latest_privacy_policy */
  accepted_terms?: boolean;
  accepted_latest_privacy_policy?: boolean;
  /**
   * One of the checkboxes on the registration page for Terms of Service.
   * Both this and accepted_sponsored_content need to be true for accepted_terms to be true.
   */
  accepted_terms_of_service?: boolean;
  /**
   * One of the checkboxes on the registration page for sponsored content.
   * Both this and accepted_terms_of_service need to be true for accepted_terms to be true.
   */
  accepted_sponsored_content?: boolean;
  name: string;
  dateOfBirth: string;
  platform?: string;
  has_full_birthday?: boolean;
  social_login?: boolean;
  transient_user_patient_status?: string;
  initial_questionnaire_name?: string;
  userRole?: string;
  doesCaregiverKnowPatientDiagnosis?: boolean;
  disease?: string;
  patientStatus?: string;
  initialDiagnosisDate?: string;
  metastaticDiagnosisDate?: string;
};

export const AUTH_METHODS = ['email', 'google', 'facebook', 'apple'];
export type AuthMethod = (typeof AUTH_METHODS)[number];

export function asAuthMethod(value: string | null): AuthMethod | undefined {
  if (value && AUTH_METHODS.includes(value)) return value;
  return undefined;
}
